import {useQuery} from 'react-query'

import {routeTo} from '@/utils/router'
import {fetch} from '@/utils/sentry-fetch/browser'
import {UserLookupResponse} from '@/utils/user/types'

export type UserLookupParams = {
  email: string
  exceptUserId?: string
  includeHistory?: boolean
}

export const fetchUser = async (params: UserLookupParams): Promise<UserLookupResponse> => {
  const response = await fetch(routeTo.api.user.get(params))

  if (!response.ok) {
    throw new Error('Failed to fetch user')
  }

  return (await response.json()) as UserLookupResponse
}

export const useUserByEmail = (params: {
  email?: string
  exceptUserId?: string
  includeHistory?: boolean
}) =>
  useQuery<UserLookupResponse>({
    queryKey: ['user', params.email, params.exceptUserId, params.includeHistory],
    // enabled guarantees email is set before this runs
    queryFn: () => fetchUser({...params, email: params.email!}),
    enabled: Boolean(params.email),
    retry: false,
    staleTime: 30_000,
  })
